export interface ShippingServiceCounter {
  shippingServiceId?: number;
  shippingServiceName?: string;
  subscriberEditions?: Array<{
    subscriberEditionStatusId?: number;
    subscriberEditionStatusName?: string;
    subscribers?: number;
  }>;
}
